import { RouteComponentProps } from '@reach/router';
import React, { ComponentType } from 'react';

export const NotFound: ComponentType<RouteComponentProps> = ({}) => {
  return <>Not found.</>;
};
